<template>
  <div id="app" class="app__main">
    <div v-if="globals.spinnerVisible" class="loading"></div>

    <nav
      class="navbar"
      id="app-navbar"
      v-bind:class="{ db_layout: feature.isDBTarget }"
    >
      <div class="container-fluid" style="padding-left: 0px">
        <ul class="nav navbar-nav">
          <li v-bind:class="{ active: !$route.name }">
            <a style="padding: 10px">
              <img
                v-if="feature.isAudiTarget"
                src="/static/audi_loop_logo.png"
                height="40"
              />
              <img
                v-else-if="feature.isDBTarget"
                src="/static/DB_loop_service_store_logo.png"
                height="25"
                style="margin-top: 5px"
              />
              <img
                v-else-if="feature.isPorscheTarget"
                src="/static/Porsche_loop_logo.png"
                height="35"
                style="margin-top: 5px"
              />
              <img v-else src="/static/msm_loop_logo.png" height="40" />
            </a>
          </li>
        </ul>
        <ul class="nav navbar-nav" v-if="!globals.isSmallScreen() && !$appService.isKeycloakUser()">
          <li
            v-if="
              globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_ReadAll')
            "
            v-bind:class="{ active: $route.name === 'SurveyView' }"
          >
            <router-link to="/surveyview">{{ lang.A0014 }}</router-link>
          </li>
          <li
            v-if="
              !globals.isSurveyCodeUser &&
              globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_ReadAll')
            "
            v-bind:class="{ active: $route.name === 'Settlement' }"
          >
            <router-link to="/settlement">{{ lang.A0030 }}</router-link>
          </li>
          <li
            v-if="!globals.isSurveyCodeUser && globals.currentUserInfo"
            v-bind:class="{ active: $route.name === 'FreeOffers' }"
          >
            <router-link to="/freeoffers">{{ lang.A0019 }}</router-link>
          </li>
        </ul>
        <ul v-else-if="!$appService.isKeycloakUser()" class="nav navbar-nav">
          <li class="dropdown">
            <a class="dropdown-toggle" data-toggle="dropdown">
              {{ currentRouteHeaderTranslation }}
              <b class="caret"></b>
            </a>
            <ul class="dropdown-menu">
              <li :class="{ 'dropdown-active': $route.name === 'SurveyView' }">
                <router-link to="/surveyview">{{ lang.A0014 }}</router-link>
              </li>
              <li
                v-if="
                  !globals.isSurveyCodeUser &&
                  globals.isAccessAllowed(
                    'LoopOp_SurveyInstancesAnswers_ReadAll'
                  )
                "
                :class="{ 'dropdown-active': $route.name === 'Settlement' }"
              >
                <router-link to="/settlement">{{ lang.A0030 }}</router-link>
              </li>
              <li
                v-if="!globals.isSurveyCodeUser"
                :class="{ 'dropdown-active': $route.name === 'FreeOffers' }"
              >
                <router-link to="/freeoffers">{{ lang.A0019 }}</router-link>
              </li>
            </ul>
          </li>
        </ul>

        <!-- RIGHT NAVIGATION PART LANGUAGE + PROFILE DROPDOWN -- START -->
        <ul v-if="userLoginState && !$appService.isKeycloakUser()" class="nav navbar-nav navbar-right">
          <!-- Language Selection -->
          <li>
            <a role="button" @click="openSelectLanguageDialog()">
              <i class="material-icons md-24">public</i>
              {{
                globals.isMobileBrowser
                  ? globals.selectedLanguage.toUpperCase()
                  : languageList[globals.selectedLanguage]
              }}
            </a>
          </li>
          <!-- User menu - only displayed if user is logged in -->
          <li class="dropdown">
            <a class="dropdown-toggle" data-toggle="dropdown">
              <i class="material-icons md-24">person</i>
              {{
                globals.isMobileBrowser ? "" : globals.currentUserInfo.LoginName
              }}
              <b class="caret"></b>
            </a>
            <ul class="dropdown-menu">
              <li v-if="globals.isSmallScreen()">
                <a style="pointer-events: none">
                  <i class="material-icons md-24">person</i>
                  {{ globals.currentUserInfo.LoginName }}
                </a>
              </li>
              <!-- <li>
                <a
                  :href="`https://${mainOpHost}/dataProtection.html`"
                  target="_blank"
                >
                  <i class="material-icons md-24">assignment</i>
                  {{ lang.A0017 }}
                </a>
              </li>
              <li>
                <a :href="`https://${mainOpHost}/imprint.html`" target="_blank">
                  <i class="material-icons md-24">info</i>
                  {{ lang.A0018 }}
                </a>
              </li> -->
              <li v-if="!globals.isSurveyCodeUser">
                <a role="button" @click="showShopperProfileModal = true">
                  <i class="material-icons md-24">portrait</i>
                  {{ lang.A0004 }}
                </a>
              </li>
              <li
                v-if="
                  !globals.isSurveyCodeUser &&
                  globals.isAccessAllowed(
                    'LoopOp_Password_ChangePasswordSelf'
                  ) &&
                  globals.isAccessAllowed('LoopOp_Password_ValidatePassword')
                "
              >
                <a role="button" @click="showChangePasswordDialog = true">
                  <i class="material-icons md-24">vpn_key</i>
                  {{ lang.A0031 }}
                </a>
              </li>
              <li v-if="globals.selectedLanguage === 'de'">
                <a role="button" @click="showHelpMessage()">
                  <i class="material-icons md-24">help_outline</i>
                  {{ lang.A0022 }}
                </a>
              </li>
              <!-- <li>
                <a role="button" target="_blank" href="http://help.msmloop.com/redmine/login">
                  <i class="material-icons md-24">live_help</i>
                  {{lang.A0021}}
                </a>
              </li>-->
              <li>
                <a role="button" @click="triggerAppRegistrationPopup()">
                  <i class="material-icons md-24">smartphone</i>
                  {{ lang.A0034 }}
                </a>
              </li>
              <li>
                <a role="button" @click="userLogout()">
                  <i class="material-icons md-24">exit_to_app</i>
                  {{ lang.A0003 }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <!-- RIGHT NAVIGATION PART LANGUAGE + PROFILE DROPDOWN -- END -->
      </div>
    </nav>
    <div class="app__router-view">
      <!-- Render components that are registered to the router only if user is logged in -->
      <router-view
        :key="$route.fullPath"
        v-if="isAccessTokenAvailable"
      ></router-view>
    </div>

    <!-- This modal is for choosing the language of the application -->
    <div class="modal fade" id="selectLanguageDialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal title -->
            <h4 class="modal-title">
              <b>{{ lang.A0006 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <p>
                <b>{{ lang.A0007 }}</b>
              </p>

              <div
                class="col-md-8 col-md-offset-2"
                style="padding-bottom: 20px"
              >
                <!-- Select for language -->
                <select
                  id="selectLanguage"
                  class="form-control language-select"
                  v-model="nextLanguage"
                >
                  <option
                    v-for="(language, isocode) in languageList"
                    :key="isocode"
                    :value="isocode"
                  >
                    {{ language }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              type="button"
              class="btn btn-raised btn-default dialog-btn-primary"
              data-dismiss="modal"
              v-on:click="changeSelectedLanguage"
            >
              {{ lang.A0009 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <ShopperProfile
      :showDialog="showShopperProfileModal"
      @modalClosed="showShopperProfileModal = false"
    ></ShopperProfile>

    <ChangePasswordDialog
      v-if="showChangePasswordDialog"
      :showDialog="showChangePasswordDialog"
      @dialogClosed="showChangePasswordDialog = false"
    ></ChangePasswordDialog>

    <!-- Confirmation Dialog -->
    <ConfirmationDialog
      :dialogId="confirmationDialogId"
      :confirmationTitle="confirmationDialogData.confirmationTitle"
      :yesButtonText="confirmationDialogData.yesButtonText"
      :noButtonText="confirmationDialogData.noButtonText"
      :showDialog="showConfirmationDialog"
      :colorRed="confirmationDialogData.colorRed"
      :htmlText="confirmationDialogData.htmlText"
      @onYesConfirmation="onYesConfirmation"
      @onNoConfirmation="onNoConfirmation"
      @dialogClosed="onConfirmationDialogClosed"
    ></ConfirmationDialog>

    <!-- Notification Dialog -->
    <NotificationDialog
      :dialogId="notificationDialogId"
      :notificationTitle="notificationDialogData.notificationTitle"
      :closeButtonText="notificationDialogData.closeButtonText"
      :showDialog="showNotificationDialog"
      :colorRed="notificationDialogData.colorRed"
      :htmlText="notificationDialogData.htmlText"
      @closeDialog="onCloseNotificationDialog"
      @dialogClosed="onNotificationDialogClosed"
    ></NotificationDialog>

    <UploadProgressModal></UploadProgressModal>

    <AppRegistrationModal
      :showModal="showAppRegistrationModal"
      @close="closeAppRegistrationModal()"
    ></AppRegistrationModal>

    <div id="defaultAppFooter">
      <span id="footerLinkContainer">
        <a :href="`https://${mainOpHost}/imprint.html`" target="_blank">{{
          lang.A0018
        }}</a>
        <a
          :href="`https://${mainOpHost}/dataProtection.html`"
          target="_blank"
          >{{ lang.A0017 }}</a
        >
      </span>

      <span id="frontendVersionIndicator">v{{ appVersion }}</span>
    </div>
  </div>
</template>

<script>
// Import CSS
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap-material-design/dist/css/bootstrap-material-design.min.css";
import "bootstrap-material-design/dist/css/ripples.min.css";

// Import JavaScript
import "bootstrap-material-design/dist/js/material.min.js";
import "bootstrap-material-design/dist/js/ripples.min.js";
import * as _ from "lodash";

// Import flatpickr
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n";

// Google Maps
import gmapsInit from "./components/Tools/gmaps";

import cssVars from "css-vars-ponyfill";

import { version as appVersion } from "../package.json";

// import dialogs
import ConfirmationDialog from "./components/Tools/Dialogs/ConfirmationDialog";
import NotificationDialog from "./components/Tools/Dialogs/NotificationDialog";
import ShopperProfile from "./components/ShopperProfile/ShopperProfile";
import ChangePasswordDialog from "./components/Tools/Dialogs/ChangePasswordDialog";
import UploadProgressModal from "./components/Tools/Dialogs/UploadProgressModal";
import AppRegistrationModal from "./components/Tools/Dialogs/AppRegistrationModal";

export default {
  name: "app",
  components: {
    ConfirmationDialog,
    NotificationDialog,
    ShopperProfile,
    ChangePasswordDialog,
    UploadProgressModal,
    AppRegistrationModal
  },
  beforeCreate() {
    $.material.init();

    if (this.feature.isAudiTarget) {
      cssVars({
        variables: {
          "color-primary": "rgb(245, 5, 55)",
          "color-primary-rgb": "245, 5, 55",
          "color-primary-input": "rgb(51, 51, 51)",
          "color-primary-input-rgb": "51, 51, 51",
          "color-primary-input-hover": "rgb(76, 76, 76)",
          "color-primary-input-hover-rgb": "76, 76, 76",
          "active-alpha": "0.2",
        },
      });
      $("head > title").text("Audi Loop");
      $("head > link[type='image/x-icon']").attr(
        "href",
        "/static/favicon-audi.webp"
      );
    } else if (this.feature.isDBTarget) {
      cssVars({
        variables: {
          "color-primary": "rgb(236, 0, 22)",
          "color-primary-rgb": "236, 0, 22",
          "color-primary-input": "rgb(79, 75, 65)",
          "color-primary-input-rgb": "79, 75, 65",
          "color-primary-input-hover": "rgb(116, 112, 103)",
          "color-primary-input-hover-rgb": "116, 112, 103",
          "active-alpha": "0.2",
        },
      });
      $("head > title").text("DB Loop");
      $("head > link[type='image/x-icon']").attr(
        "href",
        "/static/DB_loop_logo.svg"
      );
    } else if (this.feature.isPorscheTarget) {
      cssVars({
        variables: {
          "color-primary": "rgb(213, 0, 28)",
          "color-primary-rgb": "213, 0, 28",
          "color-primary-input": "rgb(79, 75, 65)",
          "color-primary-input-rgb": "79, 75, 65",
          "color-primary-input-hover": "rgb(116, 112, 103)",
          "color-primary-input-hover-rgb": "116, 112, 103",
          "active-alpha": "0.2",
        },
      });
      $("head > title").text("Porsche Loop");
      $("head > link[type='image/x-icon']").attr(
        "href",
        "/static/Porsche_logo_favico.webp"
      );
    } else cssVars();

    // Ensures that select2 and flatpickr can get input focus inside modal
    $.fn.modal.Constructor.prototype.enforceFocus = function () {};

    // Makes tooltips available for all rendered components
    $(() => {
      $('[data-toggle="tooltip"]').tooltip();
    });

    $(document).on("show.bs.modal", ".modal", function () {
      var zIndex = 1040 + 10 * $(".modal:visible").length;
      $(this).css("z-index", zIndex);
      setTimeout(() => {
        $(".modal-backdrop")
          .not(".modal-stack")
          .css("z-index", zIndex - 1)
          .addClass("modal-stack");
      }, 0);
    });
  },
  created() {
    if (location.hash.indexOf("#/surveycode") > -1) return;
    if (location.hash.indexOf("#/app-access") > -1) return;

    let checkAccessToken = () => {
      this.isAccessTokenAvailable = !!this.$appService.getAccessToken();
      if (!this.isAccessTokenAvailable) {
        console.warn("No access token available");
      }
    };

    this.globals.$off("accessTokenChanged");
    this.globals.$on("accessTokenChanged", checkAccessToken);
    checkAccessToken();

    $(document)
      .ajaxStart(() => {
        this.globals.showSpinner();
      })
      .ajaxStop(() => {
        this.globals.hideSpinner();
      });

    this.$appService.initializeGlobalAjaxEvents();

    this.globals.$off("openGlobalConfirmationDialog");
    this.globals.$on(
      "openGlobalConfirmationDialog",
      (confirmationDialogData) => {
        this.confirmationDialogData = confirmationDialogData;
        this.openConfirmationDialog();
      }
    );

    this.globals.$off("openGlobalNotificationDialog");
    this.globals.$on(
      "openGlobalNotificationDialog",
      (notificationDialogData) => {
        this.notificationDialogData = notificationDialogData;
        this.openNotificationDialog();
      }
    );

    this.initGoogleApi();

    if (this.feature.isAudiTarget)
      this.mainOpHost = "projects.audi-mysteryshopping.com";
    else if (this.feature.isDBTarget)
      this.mainOpHost = "projects.qm-servicestoredb.de";
    else if (this.feature.isPorscheTarget)
      this.mainOpHost = "projects.sar-pag.de";
  },
  mounted() {
    if (location.hash.indexOf("#/surveycode") > -1) return;
    if (location.hash.indexOf("#/app-access") > -1) return;

    // Gets executed right after rendering the component
    let userInfoCallback = () => {
      this.setInitialRoute();
      this.nextLanguage = this.globals.selectedLanguage;

      // after getCurrentUserInfo cause currentUserInfo is needed in modal
      if(!this.globals.isSurveyCodeUser && location.hash.indexOf("#/appregistration") === -1) this.GetShopperAppIdExists();
    };
    this.globals.getCurrentUserInfo(userInfoCallback);

    this.getLanguageList();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
  },
  computed: {
    userLoginState() {
      return this.globals.currentUserInfo ? true : false;
    },
    currentRouteHeaderTranslation() {
      switch (this.$route.name) {
        case "SurveyView":
          return this.lang.A0014;
        case "Settlement":
          return this.lang.A0030;
        case "Imprint":
          return this.lang.A0018;
        case "DataProtection":
          return this.lang.A0017;
        case "FreeOffers":
          return this.lang.A0019;
        default:
          return "";
      }
    },
  },
  methods: {
    async GetShopperAppIdExists() {
      await $.ajax({
        method: "GET",
        url: "shopper-api/Profile/ShopperAppIdExists",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.shopperAppIdExists = data.ShopperAppIdExists;
          if(this.shopperAppIdExists === false) this.triggerAppRegistrationPopup();
        },
        error: (error) => {
          console.error("Error on GET in GetShopperAppIdExists()", error);
        },
      });
    },
    triggerAppRegistrationPopup() {
      this.showAppRegistrationModal = true;
    },
    closeAppRegistrationModal() {
      this.showAppRegistrationModal = false;
    },
    setInitialRoute() {
      if (this.$route.name) return; // Route is already selected
      this.$router.push("surveyview");
    },

    // Opens the dialog to select a language
    openSelectLanguageDialog() {
      if (
        !this.globals.isAccessAllowed(
          "LoopOp_SecurityUsersLocalization_Update"
        ) ||
        !this.globals.isAccessAllowed("LoopOp_Language_Read")
      ) {
        this.globals.showErrorSnackbar("Access denied");
        return;
      }
      $("#selectLanguageDialog").modal("show");
    },

    userLogout() {
      this.$appService.logout();
    },

    async initGoogleApi() {
      try {
        await gmapsInit(this.globals.googleApiKey);
        this.globals.$emit("googleInitDone");
      } catch (error) {
        console.error(error);
      }
    },

    showHelpMessage() {
      //TODO: Localization
      let dialogData = {
        initiator: "appHelpMessage",
        notificationTitle: "Hilfe",
        colorRed: false,
        closeButtonText: "Schließen",
        htmlText: `<ul class="help-modal-list">
          <li>Bitte laden Sie hier das Handbuch herunter: <a href="https://projects.msmloop.com/api/Download/039a9062-0639-492b-9cc9-b044f87d61b0" target="_blank">Download Handbuch</a></li>
          <br>
          <li>Bei Fragen zum Projekt wenden Sie sich bitte an die Mail-Adresse aus dem Briefing bzw. der Auftragsmail</li>
          <br>
          <li>Bei Fragen zu Ihrer Abrechnung wenden Sie sich bitte an <a href="mailto:abrechnungen@msm-group.com">abrechnungen@msm-group.com</a></li>
          <br>
          <li>Bei allgemeinen Fragen wenden Sie sich bitte an <a href="mailto:service@msm-group.com">service@msm-group.com</a></li>
          <br>
          <li>Wenn Sie nicht mehr als Testkunde für uns arbeiten wollen, wenden Sie sich bitte an <a href="mailto:abmelden@msm-group.com">abmelden@msm-group.com</a></li>
        </ul>`,
      };
      this.globals.$emit("openGlobalNotificationDialog", dialogData);
    },

    // Closes the language selection dialog
    closeSelectLanguageDialog() {
      $("#selectLanguageDialog").modal("hide");
    },

    // Requests a list of available languages from the server
    getLanguageList() {
      $.ajax({
        method: "GET",
        url: "api/Language",
        success: (data) => {
          // this.languageList = data;
          //TODO: Only show german and english in production
          this.languageList = {
            de: data.de,
            en: data.en,
          };
          if (
            ["china", "dsinux", "local"].indexOf(this.feature.currentTarget) >
            -1
          )
            this.languageList.zh = data.zh;
        },
        error: () => {
          console.error("Language data access failed in getLanguageList()");
          // this.globals.showErrorSnackbar("Language data access failed");
        },
      });
    },
    changeSelectedLanguage() {
      if (this.nextLanguage === this.globals.selectedLanguage) return;
      let query = `api/SecurityUsers/Localization?LanguageCode=${this.nextLanguage.substring(0, 2)}`;

      $.ajax({
        method: "PUT",
        url: query,
        dataType: "text",
        success: (data) => {
          this.globals.selectedLanguage = this.nextLanguage;
          this.globals.showSuccessSnackbar(
            "Language switched to: " + this.globals.selectedLanguage
          );
        },
        error: () => {
          console.error("Error on PUT in changeSelectedLanguage()");
          this.globals.showErrorSnackbar("Language update failed");
        },
      });
    },
    openConfirmationDialog() {
      this.confirmationDialogId =
        this.confirmationDialogData.initiator + "Confirmation";
      this.showConfirmationDialog = true;
    },
    onYesConfirmation() {
      this.globals.$emit(
        this.confirmationDialogData.initiator + "YesConfirmation"
      );
      this.showConfirmationDialog = false;
    },
    onNoConfirmation() {
      this.globals.$emit(
        this.confirmationDialogData.initiator + "NoConfirmation"
      );
      this.showConfirmationDialog = false;
    },
    onConfirmationDialogClosed() {
      this.globals.$emit(
        this.confirmationDialogData.initiator + "DialogClosed"
      );
      this.showConfirmationDialog = false;
    },
    openNotificationDialog() {
      this.notificationDialogId =
        this.notificationDialogData.initiator + "Notification";
      this.showNotificationDialog = true;
    },
    onCloseNotificationDialog() {
      this.globals.$emit(this.notificationDialogData.initiator + "CloseDialog");
    },
    onNotificationDialogClosed() {
      this.globals.$emit(
        this.notificationDialogData.initiator + "DialogClosed"
      );
      this.showNotificationDialog = false;
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  data() {
    // Global data inside the component is stored here
    return {
      appVersion: appVersion,
      mainOpHost: "projects.msmloop.com",
      isAccessTokenAvailable: false,
      nextLanguage: "en",
      languageList: [], // Stores a list of all available languages
      // updateToken: false,
      lang: {
        // Contains localization strings for the selected language
        A0003: "Log Out",
        A0004: "Edit profile",
        A0006: "Language",
        A0007: "Select a language",
        A0009: "Accept",
        A0014: "Checks",
        A0015: "Survey View",
        A0017: "Data Protection",
        A0018: "Imprint",
        A0019: "Free Offers",
        A0021: "Support",
        A0022: "Help",
        A0030: "Invoice",
        A0031: "Change password",
        A0034: "App registration",
      },
      confirmationDialogData: {},
      showConfirmationDialog: false,
      notificationDialogData: {},
      showNotificationDialog: false,
      confirmationDialogId: "confirmationDialog",
      notificationDialogId: "notificationDialog",
      showShopperProfileModal: false,
      showChangePasswordDialog: false,
      showAppRegistrationModal: false,
      shopperAppIdExists: true
    };
  },
};
</script>

<style lang="scss">
@import "./styles/app-shared.scss";

/* Navbar */
.navbar {
  background-color: var(--color-primary) !important;
  margin-bottom: 0px !important;
}
.dropdown-menu > li > a:hover {
  color: black !important;
}
.dropdown-menu {
  border: solid 1px gray;
}
.dropdown > .dropdown-toggle {
  cursor: pointer;
}
#app-navbar.navbar .navbar-nav .dropdown .dropdown-active {
  background: lightgray;
}
#app-navbar.navbar .navbar-nav:not(:first-of-type) > li > a {
  padding: 20px 15px !important;
}
.navbar-nav > li > a {
  height: 60px;
}
.nav > li.active {
  background-color: rgba(255, 255, 255, var(--active-alpha)) !important;
}

// Styling for DB
.db_layout {
  box-shadow: inset 0 -6px rgb(236, 0, 22);
  background-color: white !important;

  .nav > li {
    color: rgb(0, 0, 0) !important;

    &:hover,
    &.active {
      color: rgb(236, 0, 22) !important;
    }
  }
}

/* Pagination appearance */
.pagination-fonts {
  font-size: 15px;
}
.pagination {
  display: inline-block;
}
.pagination > li > a,
.pagination > li > span {
  border: 1px solid lightgray !important;
  color: black !important;
}
.pagination > li.active > a {
  background: var(--color-primary) !important;
  color: white !important;
}
.pagination > li.disabled > a {
  background-color: #f2f2f2 !important;
}
.pagination > li.active > a:hover {
  background: rgba(var(--color-primary-rgb), 0.8) !important;
  color: white !important;
}
.dropdown-element:hover {
  background-color: #f2f2f2 !important;
  color: black;
}
.dropdown-active {
  background-color: var(--color-primary);
  color: white !important;
}
.dropdown-menu > li {
  max-height: 55px;
}
.dropdown-menu > li > a:hover.dropdown-active {
  background-color: rgba(var(--color-primary-rgb), 0.8) !important;
  color: white !important;
}

/* Input elements color */
.material-input:focus,
.form-group.is-focused .form-control:focus,
.form-control.focus {
  background-image: linear-gradient(
      var(--color-primary-input),
      var(--color-primary-input)
    ),
    linear-gradient(var(--color-primary-input), var(--color-primary-input)) !important;
}
.form-group.is-focused label,
.form-group.is-focused label.control-label {
  color: var(--color-primary-input) !important;
}

.form-group select {
  appearance: menulist !important;
}

.modal {
  overflow: auto !important;
}

.modal-dialog .form-group {
  overflow: auto;
  margin: 0;
  padding: 0;
}
.modal-dialog .form-group.has-error {
  overflow: visible;
}
.modal-dialog .form-group.has-error + .form-group {
  clear: both;
}
.modal-dialog .form-group.is-focused .help-block {
  display: none;
}
.modal-dialog .form-group.has-error.is-focused .help-block {
  display: block;
}

/** sizing for table overflow */
#the-table {
  display: block;
}

#the-table thead {
  text-align: center; /* optional */
}

#the-table tbody {
  // display: block;
  // height minus footer
  max-height: calc(70vh - 20px);
  overflow-y: scroll;
}
/** we need a fixed with for the col if we use display block to trigger scroll beahaviour
 * @link https://stackoverflow.com/questions/4457274/how-to-specify-tables-height-such-that-a-vertical-scroll-bar-appears
 */

#the-table {
  :is(td, th) {
    padding: 0;
    // word wrap on the links
    > :is(span, a, i) {
      padding: 0.11em 1em;
      display: inline-block;
      width: calc(100vw / 13);
      vertical-align: middle;
    }
  }

  :is(td, th) {
    width: calc((100% / 100) * 13);
  }
}

/**
 * recalculate for when we hide stuff
 */
@media (max-width: 1000px) {
  #the-table {
    //font-size: 2rem;
    th {
      font-size: 2.1rem;
    }
    :is(td, th) {
      padding: 0;
      // word wrap on the links
      :first-child {
        padding: 0.11em 1em;
        display: inline-block;
        width: calc(100vw / 6);
        vertical-align: middle;
      }
    }
    :is(td, th):first-child {
      width: calc((100vw / 6) * 0.5);
    }
    :is(td, th):not(:first-child) {
      width: calc((100vw / 6) * 5.5);
    }
    i {
      font-size: 3rem;
    }
  }
}

/* Padding for panel-body */
.panel > .panel-body {
  padding: 5px 0 0 0 !important;
}
.panel-collapse > .panel-body {
  padding: 5px 0 20px 0 !important;
}

.panel.panel-default > .panel-heading,
.panel > .panel-heading {
  background: var(--color-panel-heading);
}

/* Colors for radio buttons and checkboxes*/
.radio label,
.checkbox label {
  color: black;
}
.radio input[type="radio"]:checked ~ .circle {
  border-color: var(--color-primary-input) !important;
}
.radio input[type="radio"]:checked ~ .check {
  background-color: var(--color-primary-input) !important;
}
.checkbox input[type="checkbox"]:checked + .checkbox-material .check,
.checkbox input[type="checkbox"]:checked + .checkbox-material .check:before {
  color: var(--color-primary-input) !important;
  border-color: var(--color-primary-input) !important;
}
.checkbox input[type="checkbox"]:disabled + .checkbox-material .check,
.checkbox input[type="checkbox"]:disabled ~ .text {
  opacity: 0.26;
  cursor: not-allowed;
}

/* Main table */
table {
  table-layout: auto;
}
.table {
  margin-bottom: 0px !important;
}
.table-header {
  color: #004080; /* color for table header elements */
}

.main-table thead {
  width: 100%;
}
.main-table tbody {
  height: auto;
  overflow-y: scroll;
  width: 100%;
  -webkit-overflow-scrolling: touch;
}
.main-table thead tr {
  width: 100%;
  padding-right: 15px;
}
.main-table thead tr.table-filters > th {
  font-weight: normal;
}
.main-table tr {
  width: 100%;
}
.sticky-header {
  position: sticky;
  top: 0;
  background: white;

  //no wrap in header, cause it can change his size and cause problems for filter position
  white-space: nowrap;
}

.sticky-filter {
  position: sticky;
  background: white;
}

.main-table tr.info {
  background-color: #d9edf7 !important;
}
.main-table tr.info:hover {
  background-color: #c4e3f3 !important;
}
.main-table tbody td,
.main-table thead > tr > th {
  border-bottom-width: 0 !important;
}
.main-table > tbody > tr > td,
.main-table > tbody > tr > th,
.main-table > thead > tr > td,
.main-table > thead > tr > th {
  text-align: center;
}

.main-table-scrollbar::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: lightgrey;
}
.main-table-scrollbar::-webkit-scrollbar {
  width: 15px;
  z-index: 1000;
}
.main-table-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: grey;
}
.main-table .form-group ::-moz-placeholder {
  line-height: 38px !important;
}

/* Searchbar positioning */
.form-group.searchbar {
  margin-top: 0px;
}
.form-group.searchbar .form-control {
  margin-top: 10px;
}

/* Filterbar properties */
.filterbar {
  margin: 0px !important;
  padding: 0px !important;
  text-align: center;
}

/* Buttons appearance */
.btn-top-bar.btn.btn-raised {
  width: 120px;
  height: 80px;
  margin: 8px 8px 0 8px;
  padding: 0px 5px;
  font-size: 12px;
  white-space: normal;
  background-color: lightgrey;
}
.btn-top-bar.btn.btn-raised:disabled {
  background-color: white;
}
.btn-top-bar.btn.btn-raised:not(.btn-link):hover {
  background-color: #e5e5e5;
}
.btn:disabled {
  cursor: not-allowed !important;
}
.btn-top-bar.btn.btn-raised.top-btn-primary {
  background: grey;
  color: white;
}
.btn-top-bar.btn.btn-raised.top-btn-primary:not(.btn-link):hover {
  background-color: darkgrey;
}
.btn-top-bar.btn.btn-raised.top-btn-primary:disabled {
  background-color: white;
  color: rgba(0, 0, 0, 0.26);
}

#app .btn {
  text-transform: none;
}

/* Select2 styling */
.select2-dropdown {
  z-index: 1500 !important;
}

/* Disabled inputs */
.form-group input.form-control:disabled,
.form-group select.form-control:disabled,
.form-group textarea.form-control:disabled {
  background-color: rgb(240, 240, 240);
}

/* Tooltip styling */
.tooltip > .tooltip-inner {
  font-size: 14px;
  text-align: left;
  max-width: 600px;
  padding: 10px;
}

.help-modal-list {
  text-align: left;
  font-size: 16px;
}

.radio .circle {
  transform: scale(1.2);
}

.vue-treeselect--open {
  z-index: 3;
}

@media (max-width: 1000px) {
  .dropdown-menu li > a {
    font-size: 2em !important;
  }
  .nav .material-icons.md-24 {
    font-size: 36px;
    margin-top: -8px;
  }
  .btn-top-bar.btn.btn-raised {
    width: auto;
    min-width: 120px;
    padding: 0 10px;
  }
  .pagination-fonts {
    font-size: 0.6em;
  }
  .pagination > li > a {
    padding: 8px 16px !important;
  }

  .checkbox > label {
    position: relative;
    font-size: 1em !important;
    left: 15px;
  }
  .checkbox .text {
    position: relative;
    left: 15px;
    top: 5px;
  }
  .checkbox .checkbox-material > .check {
    transform: scale(1.6);
  }
  .radio .circle {
    transform: scale(1.8);
  }

  .help-modal-list {
    font-size: 1em;
  }

  .tooltip > .tooltip-inner {
    font-size: 2em;
  }

  .form-group .help-block {
    font-size: 0.8em !important;
  }

  #app-navbar .caret {
    transform: scale(1.5);
  }

  /* Overwrite some rules for portrait mode */
  @media screen and (max-aspect-ratio: 13/9) {
    #app .app__router-view {
      height: calc(100% - 80px);
    }

    .checkbox .checkbox-material > .check {
      transform: scale(2);
    }

    .radio .circle {
      transform: scale(2.2);
    }

    /* .btn-top-bar.btn.btn-raised {
      min-width: 150px;
      min-height: 100px;
    } */

    #app-navbar .caret {
      transform: scale(2);
    }

    .navbar-nav .dropdown-menu > li > a {
      font-size: 2em !important;
      line-height: 1.6em !important;
      margin: 4px 0;
    }
    .pagination .dropdown-menu > li > a {
      font-size: 2.4em !important;
      line-height: 2.4 !important;
    }
    .pagination > li > a {
      padding: 8px 20px !important;
    }

    .main-table .table-header {
      font-size: 0.8em;
    }

    #appHelpMessageNotification > .modal-dialog,
    #openSurveyConfirmationModal > .modal-dialog {
      width: 100vw;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?7b1c9aa8